/**
 * Change History
 * 08/25/2022   ptkim   Add showZero prop as boolean (default = false)
 */
import PropTypes from 'prop-types';
import React from 'react';

import useSystemSettings from '../hooks/useSystemSettings';
import { SystemSettings } from '../ifmsTypes';
import Float from '../ui/Float';

function getDecimal(systemSettings:SystemSettings, currency:string|null|undefined) {
  if (!currency) {
    return 4;
  }

  if (!!systemSettings && !!systemSettings.currencies && systemSettings.currencies.length > 0) {
    const c = systemSettings.currencies.find(x => x.currency === currency);
    return !!c ? c.decimal : 0;
  }

  return 0;
}

function formatAmount(amount:any|null|undefined, decimalCount = 2, decimal = '.', thousands = ',') {
  try {
    if (amount === null || amount === undefined) {
      return '';
    }

    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i:any = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    // console.log(e);
    return '';
  }
}

function CurrencyLabel({
  decimalOverride = undefined,
  value,
  currency,
  showZero = false,
  ...other
}: {
  decimalOverride?: number|undefined,
  value: number|null|undefined,
  currency: string,
  [x:string]:any,

}) {
  const systemSettings = useSystemSettings();
  
  const decimal = !decimalOverride ? getDecimal(systemSettings, currency) : decimalOverride;

  if(value === 0 && !showZero) value = null;
  const displayValue = (value !== null && value !== undefined)
    ? formatAmount(value, decimal, '.', ',')
    : '';

  return <Float value={parseFloat(displayValue.replace(/,/g, ''))} {...other}></Float>;
};

CurrencyLabel.propTypes = {
  value: PropTypes.number,
  currency: PropTypes.string,
  decimalOverride: PropTypes.number,
  showZero: PropTypes.bool,
  disabled: PropTypes.bool.isRequired,
};


export default React.memo(CurrencyLabel);
